import { useEffect, useState } from "react";

import "./LogisticsList.scss";
import { api } from "@utils/api";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function LogisticsListPage() {
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const [params] = useSearchParams();
	const vipCode = params.get("vipCode");
	const [logistics, setLogistics] = useState(null);
	const logisticsData = async () => {
		if (!vipCode) {
			navigate("/");
		}
		try {
			setIsLoading(true);
			await api.get(`/logistics/list/${vipCode}`).then((data) => {
				if (data.data.error !== undefined) {
					navigate("/");
					return;
				}
				setLogistics(data.data);
				setIsLoading(false);
			});
		} catch (error) {
			console.error(error);
		}
	};
	const onLogisticsStatus = (logisticsNo) => {
		navigate(`/logistics?logisticsNo=${logisticsNo}`);
	};
	useEffect(() => {
		logisticsData();
	}, []);
	return (
		<div className="logistics-list-page">
			{!isLoading ? (
				<>
					<h3 className="title">我的IUOP配送紀錄</h3>
					<div className="logistics-list-content">
						<ul>
							{logistics &&
								logistics.map((logistic) => (
									<>
										<li
											onClick={() => {
												onLogisticsStatus(logistic["logisticsNo"]);
											}}
										>
											<div className="item">
												<div className="item-img">
													<img
														src={window.assetUrl("/images/liff/brand-logo.png")}
														alt=""
													/>
												</div>
												<div className="item-content">
													<p className="order-id">
														訂單編號：{logistic["docNo"]}
													</p>
													<div className="details">
														<div className="detail-item">
															<p>消費時間</p>
															<p>{logistic["ledgerDateTime"]}</p>
														</div>
														<div className="detail-item">
															<p>商品名稱</p>
															<p>{logistic["itemName"]}</p>
														</div>
														<div className="detail-item">
															<p>物流單號</p>
															<p>{logistic["logisticsNo"]}</p>
														</div>
														<p className="btn">配送狀態</p>
													</div>
												</div>
											</div>
										</li>
									</>
								))}
						</ul>
					</div>
				</>
			) : null}
			{isLoading ? (
				<div className="pointer-events-none fixed left-0 top-0 z-[1000] flex h-svh w-full items-center justify-center bg-white">
					<img
						alt={"reload"}
						className="h-[6rem] w-[6rem] rounded-md bg-white p-4 opacity-100"
						src={window.assetUrl("/images/liff/loading.gif")}
					/>
				</div>
			) : null}
		</div>
	);
}
